import { render, staticRenderFns } from "./ReadMore.vue?vue&type=template&id=0f4521a0&scoped=true&"
import script from "./ReadMore.vue?vue&type=script&lang=ts&"
export * from "./ReadMore.vue?vue&type=script&lang=ts&"
import style0 from "./ReadMore.vue?vue&type=style&index=0&id=0f4521a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4521a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
